import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/auth';

export function PlatformAdminGuard() {
  const { user, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to={`/login?next=${encodeURIComponent(location.pathname)}`} replace />;
  }

  if (!user?.platformRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
